import { Injectable, EventEmitter, Output } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PercentageLoadingService {
    visible = new EventEmitter<boolean>();
    setVisible(isVisible: boolean) {
        this.visible.emit(isVisible);
    }

    @Output() percentage = new EventEmitter();

    updatePercentage(percentage: number) {
        this.percentage.emit(percentage);
    }
}
